import { render, staticRenderFns } from "@/modules/Carrier/templates/carriers-list.html?vue&type=template&id=5ab5b3d1&scoped=true&"
import script from "@/modules/Carrier/scripts/carriers-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Carrier/scripts/carriers-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Carrier/styles/carriers-list.scss?vue&type=style&index=0&id=5ab5b3d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab5b3d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
